// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_6R8e8","foot_link":"index_foot_link_Hu-Eb","list":"index_list_BuJ1a","link":"index_link_kHlcg","copyright":"index_copyright_zPAMV"};